;(function () {
  'use strict'

  angular
    .module('contrast.notifications')
    .directive('csCustomNotifications', csCustomNotifications)

  function csCustomNotifications() {
    return {
      restrict: 'E',
      replace: true,
      scope: false,
      templateUrl: 'components-org/notifications/cs-custom-notifications.html'
    }
  }
})()
